import * as React from 'react';

import { Seat, SeatStyle } from '../../../classes/seat';
import SeatInfoHeader from './seat-info-header';


export interface ISeatInfoHeaderContainerProps {
    seat: Seat
    useZoneDescription: boolean;
    isGAZone?: boolean;
    isInCart: boolean;
    inCartSeatStyle: SeatStyle;
    seatViewCaptionText: string;
}

class SeatInfoHeaderContainer extends React.PureComponent<ISeatInfoHeaderContainerProps, any>{
    static defaultProps = {
        isGAZone: false
    }

    getSeatDescription(props: ISeatInfoHeaderContainerProps): string {
        const { seat, isGAZone } = props;
        const description = `${this.props.useZoneDescription && seat.zoneDescription !== null ? seat.zoneDescription : seat.tessituraSeat.sectionDescription}`;
        return isGAZone ? description : description;
    }

    getSeatRowNumber(props: ISeatInfoHeaderContainerProps): string {
        const { seat, isGAZone } = props;
        return isGAZone ? ` ${seat.tessituraSeat.rowText}-${seat.tessituraSeat.numberText}` : ` ${seat.tessituraSeat.rowText}-${seat.tessituraSeat.numberText}`;
    }


    render() {
        var seatStyleToUse: SeatStyle = this.props.seat.seatStyle;
        if (this.props.isInCart && !!this.props.inCartSeatStyle) {
            seatStyleToUse = this.props.inCartSeatStyle;
        }
        return <SeatInfoHeader
            seatDescription={this.getSeatDescription(this.props)}
            seatRowNumber={this.props.isGAZone ? null : this.getSeatRowNumber(this.props)}
            seatViewCaptionText={this.props.seatViewCaptionText}
            {...seatStyleToUse}
            {...this.props.seat.originalSeatStyleCulture}
        />

    }
}

export default SeatInfoHeaderContainer;